import React from "react";
import PropTypes from "prop-types";

import ButtonStyled from "./styles";

function Button({
  children,
  disabled,
  handleClick,
  isSubmitting,
  type,
  variant,
  marginTop,
}) {
  return (
    <ButtonStyled
      type={type || "button"}
      disabled={disabled || isSubmitting}
      onClick={handleClick}
      variant={variant}
      marginTop={marginTop}
    >
      {children}
    </ButtonStyled>
  );
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  type: PropTypes.string,
  variant: PropTypes.string,
  marginTop: PropTypes.string,
};

export default Button;
